import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicHeaderThree from './EpicHeaderThree/epic.header.three.vue';
import EpicHeaderThreeSmall from './EpicHeaderThreeSmall/epic.header.three.small.vue';
import EpicMobileHeader from '../EpicMobileHeader/epic.mobile.header.vue';
@Component(
    {
        components: {
            EpicHeaderThree,
            EpicHeaderThreeSmall,
            EpicMobileHeader
        }
    }
)
export default class EpicHeaderThreeRespnosive extends Vue {
    public title: string = 'EpicHeaderThreeRespnosive';

    @Prop({ default: null })
    public data: any;

    @Prop({ default: true })
    public shadowed: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
